import type { ProgramDetail } from "@/lib/api/api-client";

/**
 * Ce qu'on montre d'un parcours qu'on n'a pas le droit d'ouvrir.
 *
 * Pas un mur : le titre, la promesse et les morceaux qu'on y joue restent là.
 * C'est ce que quelqu'un a besoin de lire pour décider s'il veut un compte, et
 * c'est ce qu'un moteur a besoin de trouver pour amener ce quelqu'un ici. Une
 * page qui ne dirait que « connectez-vous » n'aurait rien à indexer et rien à
 * convaincre.
 *
 * Ce qui manque, en revanche, manque vraiment : les jalons, les remèdes, les
 * liens pour jouer. Le serveur ne les envoie pas, donc ils ne sont pas
 * seulement cachés.
 */
export function ProgramLocked({
  program,
  color,
}: {
  program: ProgramDetail;
  color: string;
}) {
  const isPaid = program.access === "paid";

  return (
    <section className="mt-10 flex flex-col gap-5 rounded-2xl border border-border-subtle bg-white/[0.02] p-6">
      <div className="flex flex-col gap-1.5">
        <span
          className="text-[11px] font-semibold uppercase tracking-[0.15em]"
          style={{ color }}
        >
          {isPaid ? "Bloqué pour le moment" : "Compte requis"}
        </span>
        <p className="max-w-[55ch] text-[15px] leading-relaxed text-text-secondary">
          {isPaid
            ? "Ce parcours n'est pas encore ouvert. Il le sera, et tu n'as rien à faire d'ici là."
            : "Crée un compte pour ouvrir ce parcours. Le premier, lui, se joue sans rien créer."}
        </p>
      </div>

      {program.pieceTitles.length > 0 && (
        <div className="flex flex-col gap-2">
          <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-text-muted">
            Ce que tu y joueras
          </span>
          <ul className="flex flex-col gap-1">
            {program.pieceTitles.map((title) => (
              <li key={title} className="text-[14px] text-text-primary">
                {title}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
